const trips = {
  trips: 'Viajes',
  stopTypes: {
    charging: '',
    cluster: '(Centro de clúster)',
  },
  statuses: {
    new: 'Nuevo',
    in_route: 'En ruta',
    sent: 'Enviado',
    approved: 'Aprobado',
    pickingUp: 'Recogiendo',
    done: 'Listo',
    canceled: 'Cancelado',
  },
  driverActions: {
    more: 'Más',
    send: 'Enviar',
    call: 'Llamar',
    note: 'Nota',
  },
  moreActions: {
    actions: 'Más',
    sendTrip: {
      title: 'Enviar viaje',
      body: 'Está a punto de enviar {{tripsCount}} viajes',
    },
    delete: {
      title: 'Eliminar',
      body: 'Está a punto de eliminar {{tripsCount}} viajes',
    },
    addNote: {
      title: 'Añadir nota',
      body: 'Está a punto de añadir una nota a los viajes de {{tripsCount}}.',
    },
    showOnMap: 'Mostrar en el mapa',
    sendMessage: {
      title: 'Enviar mensaje',
      body: 'Está a punto de enviar un mensaje a {{tripsCount}} conductores.',
    },
    merge: {
      title: 'Combinar viajes',
      body: 'Está a punto de combinar {{tripsCount}} viajes',
    },
    cancelTrip: {
      title: 'Cancelar viaje',
      body: 'Está a punto de cancelar {{tripsCount}} viajes.',
    },
    export: 'Exportar',
    tripReports: 'Informes de viaje',
    clearAssinment: {
      title: 'Borrar asignación',
      body: 'Está a punto de borrar la asignación de {{tripsCount}} viajes.',
      confirmButton: 'Confirmar',
      checkBoxSkipManuallyAssigned: 'Omitir asignaciones manuales en esta interfaz',
    },
    clearBlacklistedDrivers: {
      title: '¿Borrar conductores bloqueados?',
      body: 'Esto eliminará cualquier conductor bloqueado de los viajes seleccionados y sus reservas asociadas - las asignaciones de conductores existentes no se ven afectadas.',
      toastSuccess: 'Conductores bloqueados borrados correctamente.',
    },
    exportToKml: {
      title: 'Exportar KML',
      body: 'Está a punto de exportar archivos KML para {{tripsCount}} viajes',
    },
    exportTripDirections: {
      title: 'Exportar Direcciones de Viaje',
      body: 'Estás a punto de exportar archivos de Excel para {{tripsCount}} viajes.',
    },
    exportToOptibus: {
      body: 'Seleccione un proyecto Optibus al que exportar los viajes:',
    },
  },
  tripInfo: {
    title: 'Viaje  ',
    formTabs: {
      detailsTab: 'Detalles',
      historyTab: 'Historia',
      assignInsightsTab: 'Asignar estadísticas',
      analysis: 'Análisis',
      feedback: 'Retroalimentación',
    },
    driverActions: {
      note: 'Nota',
      call: 'Llamar',
      send: 'Enviar',
      more: 'Más',
    },
    toast: {
      assignment: 'Viaje asignado correctamente',
      toastSomethingWasWrong: 'Algo salió mal',
      toastActionEndTrip: 'Fin de viaje disponible cuando se eliminan todos los pasajeros',
    },
    selectDriver: 'Seleccionar conductor',
    selectVehicle: 'Seleccionar Vehículo',
    bookingDetails: {
      title: 'Detalles de la reserva',
    },
    status: 'Estado',
    headerBreakDown: 'Desglose del viaje',
    driverNotAssigned: 'Conductor no asignado',
    vehicleNotAssigned: 'Vehículo no asignado',
    noDriver: 'Sin conductor',
    noCar: 'Sin Vehículo',
    noService: 'No hay servicio',
    seats: 'Asientos',
    originalStation: 'Estación original: ',
    newStation: 'Nueva estación: ',
    moveStopHeader: 'Está a punto de mover la parada del viaje: {{ tripId }}',
    date: 'Fecha',
    pickupTime: 'Hora de Recogida',
    eta: 'Próxima parada ETA',
    passengers: 'Pasajeros',
    stops: 'Paradas',
    distance: 'Distancia',
    miles: 'ml',
    kilometers: 'km',
    accept: 'Aceptar',
    decline: 'Rechazar',
    map: {
      switchRoute: {
        toasts: {
          success: 'Ruta cambiada correctamente',
          failure: 'Ocurrió un error al cambiar la ruta',
        },
      },
      operators: {
        fetchError: 'No se pudieron obtener los operadores',
        placeholder: 'Operadores',
        submit: {
          toasts: {
            success: 'Operadores actualizados correctamente',
            error: 'No se pudieron actualizar los operadores',
          },
        },
      },
      stopClusterDistance: ' ({{distance}}m para agruparse)',
    },
    modalEndTrip: {
      body: 'Marque a todos los pasajeros como dejados',
      header: '¡Advertencia!',
    },
    tripActions: {
      tripBreakdown: 'Desglose del viaje',
      note: 'Añadir nota',
      history: 'Historia',
      msg: 'Enviar un mensaje al conductor',
      moveToCustomRulesLabel: 'Crear Regla Personalizada',
      start: {
        name: 'Comenzar viaje',
        title: 'Acción disponible para el estado Aprobado',
      },
      end: {
        name: 'Fin de viaje',
        title: 'Fin de viaje disponible cuando se eliminan todos los pasajeros',
      },
      cancel: 'Cancelar viaje',
      breakdown: 'Desglose del viaje',
    },
    stopActions: {
      queue: 'Añadir a la cola',
    },
    passengerActions: {
      queue: 'Añadir a la cola',
    },
    assignLog: {
      button: 'Asignar información',
      closeButton: 'Asignar registro',
      table: {
        headers: {
          driver: 'Conductor',
          vehicle: 'Vehículo',
          score: 'Puntaje',
          flag: 'Marcar',
          minutes: 'Minutos',
          radius: 'Radio',
          seatCount: 'Recuento de asientos',
          totalTrips: 'Total de viajes',
          totalPrice: 'Precio total',
        },
      },
    },
    analysis: {
      header: 'Detalles adicionales sobre acciones manuales se pueden encontrar en la pestaña Historial de Viajes/Reservas',
      table: {
        headers: {
          name: 'Nombre',
          type: 'Tipo',
          description: 'Descripción',
          conflict: 'Conflicto',
          item1: 'Elemento 1',
          item2: 'Elemento 2',
          origin: 'Origen',
          source: 'Fuente',
        },
      },
    },
    breakdown: {
      table: {
        headers: {
          id: 'ID',
          planned: 'Tiempo planificado',
          date: 'Hora solicitada',
          passenger: 'Pasajero',
          type: 'Tipo',
          from: 'De',
          to: 'Hacia',
          vin: 'VIN',
          make: 'Fabricante',
          model: 'Modal',
          year: 'Año',
          weight: 'Peso',
          height: 'Estatura',
          width: 'Ancho',
          length: 'Largo',
          price: 'Precio',
        },
      },
    },
    tripsInfoPlans: {
      toastStatusChanged: 'Estado cambiado',
      toastStopRemoved: 'Parada eliminada',
      toastTripRemoved: '[Viajes] Eliminados correctamente',
      toastTripRemoveError: '[Viajes] No se pudo eliminar',
      toastClearSuccess: '[Viajes] Los conductores y vehículos se eliminaron correctamente',
      toastClearError: '[Viajes] Los conductores y vehículos se eliminaron correctamente',
      toastTripCanceled: '[Viajes] cancelado correctamente',
      toastTripCanceledError: '[Viajes] no se pudieron cancelar',
      toastJobRemoved: 'Se eliminó la reserva',
      toastJobCanceld: 'La reserva ha sido cancelada correctamente',
      toastSomethingWasWrong: 'Algo salió mal',
      toastMergeSuccess: 'Los viajes se combinaron correctamente',
      toastMergeManyLockedAssignments: 'No se pueden combinar viajes porque tienen varias asignaciones bloqueadas diferentes',
      toastMergeError: 'Uno de las viajes no está disponible para combinar',
      btnRemoveStop: 'Quitar',
      reservationActions: {
        btnPickUp: {
          name: 'Recogido',
          title: 'Disponible solo para estado en ruta',
        },
        btnDroppoff: {
          name: 'Dejado',
          title: 'Disponible solo para estado en ruta',
        },
        btnNoShow: {
          name: 'No apareció',
          title: 'Disponible solo para estado en ruta',
        },
        btnCancel: 'Cancelar reserva',
        btnRemove: 'Eliminar del viaje',
      },
    },
    events: {
      chargingStationAdded: 'Añadida estación de carga',
    },
    moveReservation: {
      successToast: 'Reserva movida con éxito',
      errorToast: 'Error al mover la reserva',
    },
    moveStops: {
      successToast: 'Paradas reordenadas con éxito',
      errorToast: 'Failed to reorder stops',
    },
  },
  edit: {
    applyingEditChanges: 'Aplicando cambios',
    progress: {
      toastSuccess: 'Puntos de ruta guardados',
      toastError: 'Error al aplicar los puntos de ruta',
    },
    unsaved: {
      header: 'Cambios sin guardar',
      body: 'Tienes cambios sin guardar. ¿Qué te gustaría hacer?',
      confirm: 'Descartar cambios',
      cancel: 'Mantener cambios',
    },
  },
  table: {
    floatingActions: {
      tooltips: {
        deleteNotNew: 'Al menos un viaje no está en estado new',
        noPermission: 'Acción no permitida: Se requiere permiso',
        accept: 'Esta acción solo está disponible para viajes con estado `Accept` o `Decline`.',
        decline: 'Esta acción solo está disponible para viajes con estado `Accept` o `Decline`.',
      },
      assign: 'Asignar',
      send: 'Enviar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      export: 'Exportar',
      merge: 'Combinar',
      sendMessage: 'Enviar mensaje',
      tripReport: 'Informe de viaje',
      showOnMap: 'Mostrar en el mapa',
      addNote: 'Añadir nota',
      exportToKml: 'Exportar a KML',
      exportTripDirections: 'Exportar Direcciones de Viaje',
      exportToOptibusPlanning: 'Exportar a Planificación',
      exportToOptibusScheduling: 'Exportar a Programación',
      accept: 'Aceptar',
      decline: 'Rechazar',
    },
    filters: {
      status: 'Estado',
      profile: 'Perfiles',
      attributes: 'Atributos',
      supplier: 'Proveedores',
      driver: 'Conductor',
      vehicle: 'Vehículo',
      from: 'De',
      to: 'Hacia',
      locations: 'Ubicaciones',
      airportLocations: 'Ubicaciones de Aeropuerto',
      flightNumber: 'Número de Vuelo',
      airline: 'Aerolínea',
      flightStatus: 'Estado del Vuelo',
      productionId: 'ID de producción',
      drivers: {
        onlyWithout: 'Viajes sin asignar',
        onlyWith: 'Viajes asignados',
        all: 'Asignado y sin asignar ',
      },
      vehicles: {
        onlyWithout: 'Vehículo sin asignar',
        onlyWith: 'Vehículo asignado',
        all: 'Asignado y sin asignar',
      },
      areas: 'Zonas',
    },
    buttons: {
      driver: 'Conductor',
      vehicle: 'Vehículo',
    },
    statuses: {
      new: 'Nuevo',
      inRoute: 'En ruta',
      sent: 'Enviado',
      approved: 'Aprobado',
      pickingUp: 'Recogiendo',
      done: 'Listo',
      canceled: 'Cancelado',
    },
    indicators: {
      consistentPassengerRouting: 'Enrutamiento Consistente de Pasajeros',
      error: 'Investigación',
      manualDispatched: 'Despacho Manual',
    },
    headers: {
      id: 'ID',
      indicators: 'Indicadores',
      status: 'Estado',
      date: 'Fecha',
      from: 'De',
      to: 'Hacia',
      seats: 'Asientos',
      passenger: 'Pasajero',
      profile: 'Perfil',
      stops: 'Paradas',
      distance: 'Distancia',
      duration: 'Duración',
      service: 'Servicio',
      flightInfo: 'Información del Vuelo',
      flightNumber: 'Número de Vuelo',
      airline: 'Aerolínea',
      scheduledFlightTime: 'Hora Programada del Vuelo',
      actualFlightTime: 'Hora Real del Vuelo',
      flightStatus: 'Estado del Vuelo',
      supplier: 'Proveedor',
      driver: 'Conductor',
      car: 'Vehículo',
      actions: 'Acciones',
      attr: 'Atributos',
      externalId: 'ID externo',
      waitUntil: 'Espere hasta',
      line: 'Línea',
      reservationsExtendUntilDate: 'Espere hasta',
      areas: 'Zonas',
    },
    footer: {
      totalSeats: 'Total de asientos: {{seats}}',
    },
    cells: {
      isTwoWay: {
        toolTip: 'Bidireccional',
      },
      shared: {
        toolTip: 'Viaje compartido',
      },
      waitAndReturn: {
        toolTip: 'Espera y vuelve',
      },
      chargingStops: {
        toolTip: 'Paradas de Recarga',
      },
      manualAssignment: {
        integration: {
          toolTip: 'Asignada manualmente (integración)',
        },
        noIntegration: {
          toolTip: 'Asignada manualmente',
        },
      },
      bypassed: {
        toolTip: 'Configuraciones anuladas por acción manual',
      },
      isManuallyAltered: {
        toolTip: 'Despacho Manual',
      },
      manualDispatch: {
        and: '&',
        reason: {
          grouped: 'Agrupado',
          manualRoute: 'Ruta Manual',
          dragAndDrop: 'Arrastrar y Soltar',
          manualRouteIntegration: 'Ruta Manual (Integración)',
        },
      },
      car: {
        none: 'Sin vehículo',
      },
      driver: {
        none: 'Sin conductor',
      },
      supplier: {
        none: 'No hay proveedor',
      },
      actions: {
        approve: 'Aprobar',
        remove: 'Remover',
      },
    },
    actions: {
      autoAssign: {
        modal: {
          header: 'Resumen de la Asignación',
          body: {
            trips: {
              total: 'Total de Viajes',
              assigned: 'Total Asignado',
              unassigned: 'No Asignado',
            },
            drivers: {
              autoAssigned: 'Asignado Automáticamente',
              preAssigned: 'Preasignado',
              total: 'Total de Conductores',
              totalDriversAssigned: 'Total Assigned',
              unassigned: 'Unassigned',
            },
            vehicles: {
              total: 'Total de Vehículos',
              used: 'Total Asignado',
            },
            insights: {
              title: 'Perspectivas de Asignaciones',
              assignmentTime: 'Assignment Process Time',
              avgDistance: 'Distâncias Médias de Viagem',
              avgDistanceToPickup: 'Distancia Promedio de Conducción Vacía',
              avgDuration: 'Duración Promedio de Viaje',
              avgDurationToPickup: 'Distancia Promedio de Conducción Vacía',
              avgPrice: 'Precio Promedio',
              waitAvg: 'Tiempo Promedio de Inactividad',
            },
          },
        },
        errorModal: {
          header: 'Error',
          body: 'Todos los viajes seleccionados ya fueron asignados. Para reasignar conductores, primero borre la asignación actual.',
        },
      },
      assign: {
        assign: 'Asignar',
        clearDriversVehicle: 'Borrar conductores / vehículos',
        clearBlacklistedDrivers: 'Borrar conductores bloqueados',
        advancedAssign: 'Asignación avanzada',
        modalHeader: 'Asignar viaje',
        youAreAboutToAssign: 'Está a punto de asignar {{numberOfTrips}} viajes.',
      },
      merge: {
        errorMessage: 'No se encontró el viaje adicional para combinar',
        shuttle: 'No se permite combinar los viajes de Shuttle',
      },
      showOnMap: {
        header: 'Mostrar en el mapa',
        shuttle: 'No se permite combinar los viajes de Shuttle',
      },
      export: {
        optibus: {
          header: 'Proyectos',
          placeholder: 'Seleccionar proyecto',
          export: 'Exportar',
          success: 'Los viajes seleccionados se enviaron correctamente al proyecto Optibus seleccionado.',
        },
      },
      cancelReservation: 'Está a punto de cancelar esta reserva',
      report: {
        header: 'Resumen de ruta',
        body: {
          totalTrips: 'Viajes',
          totalCost: 'Coste',
          totalPrice: 'Precio',
          totalJobs: 'Reservas',
          totalDuration: 'Duración',
          totalDistance: 'Distancia',
          totalAssigned: 'Asignado',
          totalUnassigned: 'Sin asignar',
          totalDrivers: 'Conductores',
          averageJobs: 'Promedio reservas',
          averageDistance: 'Promedio Distancia',
          averageDuration: 'Promedio Duración',
        },
      },
    },
  },
};

export default trips;
